<template>
  <div class="home-tab">
    <section class="hero">
      <div class="container hero-grid">
        <div class="hero-copy reveal">
          <div class="badge">新锐品牌数字化实践者 · 打造智慧出行生态</div>
          <h1>
            构建基层治理
            <span>智慧新范式</span>
          </h1>
          <p>
            深耕浙江，辐射全国。中鸿云智为您提供从“无人值守”到“数智入厅”的全方位数字化转型解决方案。
          </p>
          <div class="hero-actions">
            <button type="button" @click="$emit('jump-tab', 'products')">了解产品</button>
            <button type="button" class="ghost" @click="$emit('jump-tab', 'about')">成功案例</button>
          </div>
        </div>

        <div class="hero-media reveal">
          <img src="@/assets/home/home-hero.png"/>
          <div class="score-card">
            <span>满意度</span>
            <strong>95.8% +</strong>
          </div>
        </div>
      </div>
    </section>

    <section class="stats reveal">
      <div class="container stats-grid">
        <article v-for="item in stats" :key="item.value" class="stat-item">
          <strong>{{ item.value }}</strong>
          <span>{{ item.label }}</span>
        </article>
      </div>
    </section>

    <section class="section">
      <div class="container">
        <header class="section-head reveal center">
          <small>CORE VALUES</small>
          <h2>我们解决的核心问题</h2>
        </header>
       
        <div class="problem-grid">
          <article v-for="item in problems" :key="item.title" class="problem-card reveal">
            <img class="icon" :src="item.icon" />
            <div class="problem-copy">
              <h3>{{ item.title }}</h3>
              <p>{{ item.desc }}</p>
            </div>
          </article>
        </div>
      </div>
    </section>

    <section class="section white">
      <div class="container">
        <header class="section-head reveal">
          <small>SOLUTIONS</small>
          <div class="head-row">
            <h2>核心行业解决方案</h2>
            <button type="button" class="link-btn" @click="$emit('jump-tab', 'products')">查看全部方案</button>
          </div>
          <p>融合云计算、大数据、AI 等前沿技术，我们在政务与场域管理两大核心领域积累深厚实战经验。</p>
        </header>

        <article class="solution reveal">
          <div class="copy">
            <div class="icon">
               <img src="@/assets/home/unattended.png"  />
            </div>
            <h3>场域无人值守解决方案</h3>
            <p>中鸿小门神指挥中枢，将传统的、分散的管理节点升级为协同联动枢纽，从根源提升基层治理水平。</p>
            <ul class="tags">
              <li>智能门禁</li>
              <li>停车管理</li>
              <li>实时预警</li>
            </ul>
          </div>
          <img src="@/assets/home/case1.png"  />
        </article>

        <article class="solution dark reverse reveal">
          <div class="copy">
            <div class="icon">
                <img src="@/assets/home/plan.png"  />
            </div>
            <h3>数企通政务解决方案</h3>
            <p>用数字技术创新政务履职方式，赋能高效治理，助力政府部门从“治理”向“智理”转变。</p>
            <ul class="checks">
              <li>定制化软件研发服务</li>
              <li>全场景数字化大屏支撑</li>
            </ul>
          </div>
          <img src="@/assets/home/case2.png"  />
        </article>
      </div>
    </section>

    <section class="partners section">
      <div class="container">
        <p class="partner-title reveal">与众多知名企业与政务单位并肩前行</p>
        <div class="partner-marquee reveal">
          <div class="partner-track">
            <div class="partner-item" v-for="(item, index) in partnerLoop" :key="`${item.alt}-${index}`">
              <img :src="item.src" :alt="item.alt" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section cta-wrap">
      <div class="container">
        <div class="cta reveal">
          <h2>准备好开启数字化转型之旅了吗？</h2>
          <p>联系我们的专家团队，获取为您业务量身定制的数字化解决方案。</p>
          <div class="cta-actions">
            <button type="button" @click="$emit('jump-tab', 'contact')">免费预约演示</button>
            <span>咨询热线: 0571-28113599</span>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import problemA from '@/assets/home/problem_a.png'
import problemB from '@/assets/home/problem_b.png'
import problemC from '@/assets/home/problem_c.png'
import problemD from '@/assets/home/problem_d.png'
import problemE from '@/assets/home/problem_e.png'
import problemF from '@/assets/home/problem_f.png'
import partner1 from '@/assets/home/partner1.png'
import partner2 from '@/assets/home/partner2.png'
import partner3 from '@/assets/home/partner3.png'
import partner4 from '@/assets/home/partner4.png'
import partner5 from '@/assets/home/partner5.png'
import partner6 from '@/assets/home/partner6.png'
import partner7 from '@/assets/home/partner7.png'
import partner8 from '@/assets/home/partner8.png'

export default {
  name: 'HomeTab',
  data() {
    return {
      stats: [
        { value: '30+', label: '自主知识产权软著' },
        { value: '20+', label: '浙江省地市覆盖' },
        { value: '100W+', label: '累计服务用户数' },
        { value: '1对1', label: '全生命周期定制化' }
      ],
      problems: [
        { icon: problemA, title: '无人值守', desc: '构建基层治理智慧新范式，塑造“智慧城市”建设标杆。' },
        { icon: problemB, title: '企业诉求解决', desc: '打破政企沟通壁垒，让企业诉求直达职能部门并形成闭环。' },
        { icon: problemC, title: '数字一体化', desc: '数字大屏实时反馈，提升管理透明度与决策效率。' },
        { icon: problemD, title: '数字广告', desc: '公域投放追踪 + 私域精细运营，实现全域数字化营销。' },
        { icon: problemE, title: '营销决策', desc: '多维数据组合分析，强化数据驱动投放，提升 ROI。' },
        { icon: problemF, title: '在线客服', desc: '实现企业不间断服务，节约人力成本并提升客户满意度。' }
      ],
      partnerMarks: [
        { src: partner1, alt: '合作伙伴1' },
        { src: partner2, alt: '合作伙伴2' },
        { src: partner3, alt: '合作伙伴3' },
        { src: partner4, alt: '合作伙伴4' },
        { src: partner5, alt: '合作伙伴5' },
        { src: partner6, alt: '合作伙伴6' },
        { src: partner7, alt: '合作伙伴7' },
        { src: partner8, alt: '合作伙伴8' }
      ]
    }
  },
  computed: {
    partnerLoop() {
      return [...this.partnerMarks, ...this.partnerMarks]
    }
  }
}
</script>

<style scoped lang="less">
@primary: #2f67ea;

.container {
  width: min(1240px, calc(100% - 48px));
  margin: 0 auto;
}

.hero {
  padding: 40px 0 26px;
}

.hero-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 34px;
  align-items: center;
}

.badge {
  display: inline-flex;
  min-height: 30px;
  border-radius: 16px;
  padding: 0 12px;
  align-items: center;
  font-size: 12px;
  color: #2f67ea;
  background: #eaf2ff;
}

.hero-copy h1 {
  margin: 14px 0 12px;
  line-height: 1.08;
  font-size: clamp(32px, 4.2vw, 56px);
}

.hero-copy h1 span {
  display: block;
  color: @primary;
}

.hero-copy p {
  margin: 0;
  color: #617893;
  line-height: 1.9;
  font-size: 17px;
}

.hero-actions {
  margin-top: 18px;
  display: flex;
  gap: 10px;
}

.hero-actions button {
  min-height: 44px;
  border-radius: 11px;
  border: 0;
  padding: 0 22px;
  cursor: pointer;
  font-weight: 700;
  color: #fff;
  background: #091631;
}

.hero-actions button.ghost {
  color: #243855;
  background: #fff;
  border: 1px solid #dce7fa;
}

.hero-media {
  position: relative;
  animation: floatY 4.6s ease-in-out infinite;
}

.hero-media img {
  width: 100%;
  border-radius: 16px;
  border: 2px solid #fff;
  box-shadow: 0 16px 30px rgba(16, 51, 108, 0.14);
}

.score-card {
  position: absolute;
  left: -16px;
  bottom: -18px;
  background: rgba(255, 255, 255, 0.94);
  border: 1px solid #e1eafe;
  border-radius: 14px;
  padding: 11px 14px;
  box-shadow: 0 10px 20px rgba(20, 52, 101, 0.14);
}

.score-card span {
  display: block;
  font-size: 12px;
  color: #6f86a5;
}

.score-card strong {
  display: block;
  color: #182b4b;
  font-size: 26px;
  line-height: 1.2;
}

.stats {
  padding-top: 30px;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  background: #fff;
  border: 1px solid #ebf0f8;
}

.stat-item {
  min-height: 110px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  transition: background 0.25s ease;
}

.stat-item + .stat-item {
  border-left: 1px solid #edf2fb;
}

.stat-item strong {
  font-size: 30px;
  color: @primary;
}

.stat-item span {
  margin-top: 4px;
  color: #7387a6;
  font-size: 12px;
}

.stat-item:hover {
  background: #f7faff;
}

.section {
  padding: 62px 0;
}

.section.white {
  background: #fff;
}

.center {
  text-align: center;
}

.section-head small {
  color: @primary;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1px;
}

.section-head h2 {
  margin: 10px 0 0;
  font-size: clamp(28px, 3.2vw, 42px);
}

.section-head p {
  margin: 8px 0 0;
  color: #667d9a;
  line-height: 1.8;
}

.head-row {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 14px;
}

.link-btn {
  border: 0;
  background: none;
  color: @primary;
  font-weight: 700;
  cursor: pointer;
}

.problem-grid {
  margin-top: 28px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 22px;
}

.problem-card {
  border: 1px solid #e6edf8;
  border-radius: 14px;
  background: #fff;
  min-height: 168px;
  padding: 24px 30px;
  display: flex;
  align-items: center;
  gap: 20px;
  transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;
}

.problem-card .icon {
  width: 118px;
  height: 118px;
  object-fit: contain;
  flex: 0 0 118px;
}

.problem-copy {
  flex: 1;
}

.problem-card h3 {
  margin: 0 0 10px;
  font-size: 22px;
  line-height: 1.15;
}

.problem-card p {
  margin: 0;
  color: #647a95;
  line-height: 1.65;
  font-size: 16px;
}

.problem-card:hover {
  transform: translateY(-5px);
  border-color: #cfe0ff;
  box-shadow: 0 14px 28px rgba(26, 59, 115, 0.12);
}

.solution {
  margin-top: 20px;
  border-radius: 30px;
  overflow: hidden;
  display: grid;
  grid-template-columns: 1fr 1fr;
  background: #f5f8fd;
}

.solution.dark {
  background: #091631;
  color: #fff;
}

.solution.dark .copy p {
  color: #b9cae4;
}

.solution.dark .checks li {
  color: #c9d8ee;
}

.solution.reverse .copy {
  order: 2;
}

.solution.reverse img {
  order: 1;
}

.solution img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.6s ease;
}

.copy {
  padding: 32px;
}

.solution:hover img {
  transform: scale(1.035);
}

.copy .icon {
  width: 38px;
  height: 38px;
  border-radius: 12px;
  background: #3b82f6;
  color: #2c65df;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 700;
}

.copy h3 {
  margin: 14px 0 10px;
  font-size: clamp(24px, 2.8vw, 34px);
}

.copy p {
  margin: 0;
  color: #5f7693;
  line-height: 1.9;
}

.tags,
.checks {
  margin: 14px 0 0;
  padding: 0;
  list-style: none;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.tags li {
  min-height: 30px;
  padding: 0 12px;
  border-radius: 15px;
  display: inline-flex;
  align-items: center;
  border: 1px solid #dce6f8;
  background: #fff;
  font-size: 12px;
}

.checks li {
  width: 100%;
  font-size: 14px;
}

.partners {
  background: #f7f9fd;
}

.partner-title {
  text-align: center;
  color: #8e9eba;
  letter-spacing: 2px;
  font-size: 18px;
}

.partner-marquee {
  margin-top: 50px;
  overflow: hidden;
  border-radius: 12px;
}

.partner-track {
  display: flex;
  align-items: center;
  width: max-content;
  gap: 12px;
  padding: 8px 0;
  animation: partnerScroll 28s linear infinite;
}

.partner-item {
  width: 172px;
  height: 72px;
  flex: 0 0 172px;
  border-radius: 11px;
  background: #fff;
  border: 1px solid #e2eaf8;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.22s ease, box-shadow 0.22s ease, border-color 0.22s ease;
}

.partner-item img {
  width: 82%;
  height: 82%;
  object-fit: contain;
}

.partner-item:hover {
  transform: translateY(-4px);
  border-color: #cedeff;
  box-shadow: 0 10px 20px rgba(20, 51, 103, 0.1);
}

.partner-marquee:hover .partner-track {
  animation-play-state: paused;
}

.cta-wrap {
  padding-top: 34px;
}

.cta {
  border-radius: 26px;
  padding: 54px 20px;
  text-align: center;
  color: #fff;
  background: linear-gradient(130deg, #2f67ea 0%, #305fd8 100%);
}

.cta h2 {
  margin: 0;
  font-size: clamp(28px, 3vw, 40px);
}

.cta p {
  margin: 10px 0 18px;
  color: #dce7ff;
}

.cta-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

.cta-actions button {
  border: 0;
  min-height: 44px;
  padding: 0 20px;
  border-radius: 22px;
  color: #2f67ea;
  background: #fff;
  font-weight: 700;
  cursor: pointer;
  transition: transform 0.22s ease, box-shadow 0.22s ease;
}

.cta-actions button:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 22px rgba(19, 56, 120, 0.24);
}

@keyframes floatY {
  0% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
  100% { transform: translateY(0); }
}

@keyframes partnerScroll {
  from { transform: translateX(0); }
  to { transform: translateX(-50%); }
}

.cta-actions span {
  color: #dce7ff;
}

@media (max-width: 1024px) {
  .container {
    width: min(1240px, calc(100% - 36px));
  }

  .hero-grid,
  .solution {
    grid-template-columns: 1fr;
  }

  .solution.reverse .copy,
  .solution.reverse img {
    order: initial;
  }

  .problem-grid {
    gap: 16px;
  }

  .partner-item {
    width: 146px;
    height: 66px;
    flex-basis: 146px;
  }
}

@media (max-width: 768px) {
  .container {
    width: min(1240px, calc(100% - 24px));
  }

  .hero-copy h1 {
    font-size: 36px;
  }

  .hero-copy p,
  .problem-card p,
  .copy p {
    font-size: 14px;
  }

  .hero-actions {
    flex-direction: column;
  }

  .hero-actions button {
    width: 100%;
  }

  .score-card {
    position: static;
    margin-top: 10px;
  }

  .hero-media {
    animation: none;
  }

  .stats-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .stat-item:nth-child(3),
  .stat-item:nth-child(4) {
    border-top: 1px solid #edf2fb;
  }

  .problem-grid {
    grid-template-columns: 1fr;
  }

  .problem-card {
    min-height: auto;
    padding: 18px;
    gap: 14px;
    align-items: flex-start;
  }

  .problem-card .icon {
    width: 72px;
    height: 72px;
    flex-basis: 72px;
  }

  .problem-card h3 {
    margin-bottom: 6px;
    font-size: 18px;
  }

  .partner-item {
    width: 132px;
    height: 62px;
    flex-basis: 132px;
  }

  .head-row {
    align-items: flex-start;
    flex-direction: column;
  }

  .cta-actions {
    flex-direction: column;
  }
}
</style>
